export default {
  Default: {
    Equal: 'filters.operators.default.Equal',
    NotEqual: 'filters.operators.default.NotEqual',
    LessThan: 'filters.operators.default.LessThan',
    LessThanOrEqual: 'filters.operators.default.LessThanOrEqual',
    GreaterThan: 'filters.operators.default.GreaterThan',
    GreaterThanOrEqual: 'filters.operators.default.GreaterThanOrEqual'
  },
  Date: {
    Equal: 'filters.operators.default.Equal',
    NotEqual: 'filters.operators.default.NotEqual',
    LessThan: 'filters.operators.date.LessThan',
    LessThanOrEqual: 'filters.operators.date.LessThanOrEqual',
    GreaterThan: 'filters.operators.date.GreaterThan',
    GreaterThanOrEqual: 'filters.operators.date.GreaterThanOrEqual'
  },
  Contains: {
    Equal: 'filters.operators.contains.Equal',
    NotEqual: 'filters.operators.contains.NotEqual',
    LessThan: 'filters.operators.default.LessThan',
    LessThanOrEqual: 'filters.operators.default.LessThanOrEqual',
    GreaterThan: 'filters.operators.default.GreaterThan',
    GreaterThanOrEqual: 'filters.operators.default.GreaterThanOrEqual'
  }
}
